import { z } from 'zod';
import { positiveDecimal, rate } from './primitives.js';

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, { error: 'Date attendue (AAAA-MM-JJ)' });
const blankable = z.union([positiveDecimal, z.literal('')]).optional();

export const measurementSchema = z.object({
  version: z.number().int().positive(),
  dimUnit: z.enum(['m', 'cm', 'mm']).default('m'),
  rows: z
    .array(
      z.object({
        label: z.string().trim().max(120).optional(),
        deduct: z.boolean().optional(),
        count: blankable,
        length: blankable,
        width: blankable,
        height: blankable,
        value: blankable,
      }),
    )
    .min(1, { error: 'Ajoutez au moins une ligne au tableau' })
    .max(500),
});

export const analysisSchema = z.object({
  version: z.number().int().positive(),
  yieldPerPeriod: positiveDecimal.nullable().optional(),
  components: z
    .array(
      z.object({
        kind: z.enum(['MATERIAL', 'LABOR', 'EQUIPMENT', 'MACHINE', 'TRANSPORT', 'OTHER']),
        designation: z.string().trim().min(1).max(200),
        unit: z.string().trim().min(1).max(20),
        quantity: positiveDecimal,
        unitPrice: positiveDecimal,
        lossRate: rate.optional(),
        atYield: z.boolean().optional(),
        source: z.string().trim().max(200).optional(),
      }),
    )
    .min(1, { error: 'Ajoutez au moins une ressource' })
    .max(100),
});

export const lineVersionSchema = z.object({ version: z.number().int().positive() });

export const priceListSchema = z.object({
  name: z.string().trim().min(2).max(120),
  countryCode: z.string().length(2).toUpperCase().nullable().optional(),
  region: z.string().trim().max(120).nullable().optional(),
  currency: z.string().length(3).toUpperCase(),
  validFrom: isoDate,
  validTo: isoDate.nullable().optional(),
  notes: z.string().trim().max(1000).nullable().optional(),
});
export const priceListUpdateSchema = priceListSchema.omit({ currency: true }).partial().extend({ version: z.number().int().positive(), isActive: z.boolean().optional() });
export const priceListDuplicateSchema = z.object({ name: z.string().trim().min(2).max(120), validFrom: isoDate, validTo: isoDate.nullable().optional(), region: z.string().trim().max(120).nullable().optional() });

export const PRICE_ITEM_KINDS = ['MATERIAL', 'LABOR', 'EQUIPMENT', 'WORK'] as const;
export const priceItemSchema = z.object({
  kind: z.enum(PRICE_ITEM_KINDS),
  code: z.string().trim().regex(/^[A-Za-z0-9_.-]{1,40}$/, { error: 'Code : lettres, chiffres, _ . -' }),
  designation: z.string().trim().min(1).max(300),
  unit: z.string().trim().min(1).max(20),
  price: positiveDecimal,
  source: z.string().trim().max(200).nullable().optional(),
});
export const priceItemUpdateSchema = z.object({ version: z.number().int().positive(), designation: z.string().trim().min(1).max(300).optional(), unit: z.string().trim().min(1).max(20).optional(), price: positiveDecimal.optional(), source: z.string().trim().max(200).nullable().optional() });

export const linePriceFromListSchema = z.object({ version: z.number().int().positive(), itemId: z.uuid() });
export const projectPriceListSchema = z.object({ priceListId: z.uuid().nullable() });
